export default __webpack_public_path__ + "static/media/awaj.34405f2e.png";